/**
 * 인증 토큰 관련 유틸리티 함수
 */

/**
 * 토큰 저장
 */
export const setAuthToken = (token) => {
  localStorage.setItem('authToken', token);
};

/**
 * 토큰 가져오기
 */
export const getAuthToken = () => {
  return localStorage.getItem('authToken');
};

/**
 * 토큰 삭제
 */
export const removeAuthToken = () => {
  localStorage.removeItem('authToken');
};

/**
 * 인증 여부 확인
 */
export const isAuthenticated = () => {
  const token = getAuthToken();
  if (!token) {
    return false;
  }

  // 토큰 만료 시간 확인
  const expiresAt = localStorage.getItem('tokenExpiresAt');
  if (expiresAt && Date.now() > parseInt(expiresAt)) {
    // 토큰이 만료됨
    removeAuthToken();
    removeUserInfo();
    localStorage.removeItem('tokenExpiresAt');
    return false;
  }

  return true;
};

/**
 * 사용자 정보 저장
 */
export const setUserInfo = (userInfo) => {
  localStorage.setItem('userInfo', JSON.stringify(userInfo));
};

/**
 * 사용자 정보 가져오기
 */
export const getUserInfo = () => {
  const userInfo = localStorage.getItem('userInfo');
  return userInfo ? JSON.parse(userInfo) : null;
};

/**
 * 사용자 정보 삭제
 */
export const removeUserInfo = () => {
  localStorage.removeItem('userInfo');
};

/**
 * Axios 요청에 토큰 추가하는 인터셉터 함수
 */
export const addAuthTokenToHeader = (config) => {
  const token = getAuthToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
};

